import { ca } from '@cian/analytics';
import { prerareQueryString } from '../../../../utils/prerareQueryString';
import { ESavedSearchFrequency } from '../../../../types/savedSearch';

export function trackClickDeleteSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'click_delete',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export function trackNavigateToSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'to_savesearch',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export const schedule: { [key: string]: string } = {
  [ESavedSearchFrequency.None]: 'no_notification',
  [ESavedSearchFrequency.Asap]: 'instantly',
  [ESavedSearchFrequency.Daily]: 'daily',
  [ESavedSearchFrequency.Hourly]: 'hourly',
};

export function trackChangeScheduleSavedSearch(freq: ESavedSearchFrequency | null, link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'change_schedule',
    page: {
      extra: {
        queryString: prerareQueryString(link),
        schedule: freq && schedule[freq],
      },
    },
  });
}
